import React from "react";
import { Calendar, MapPin } from "lucide-react";

export default function ScheduleTable({ schedule, teamsBySlug }) {
  return (
    <div data-testid="schedule-table" className="overflow-x-auto border border-white/10">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-white/55">
            <th className="text-left font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10">Date</th>
            <th className="text-left font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10">Match</th>
            <th className="text-left font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10 hidden md:table-cell">Venue</th>
            <th className="text-left font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10 hidden sm:table-cell">Time</th>
            <th className="text-right font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10">Status</th>
          </tr>
        </thead>
        <tbody>
          {schedule.map((m) => {
            const home = teamsBySlug[m.home];
            const away = teamsBySlug[m.away];
            return (
              <tr key={m.id} data-testid={`schedule-row-${m.id}`} className="hover:bg-white/5 transition-colors">
                <td className="py-4 px-4 border-b border-white/5 align-top">
                  <div className="flex items-center gap-2 text-white">
                    <Calendar className="h-3.5 w-3.5 text-pshl-electric" />
                    <span className="font-mono text-xs">{m.date}</span>
                  </div>
                </td>
                <td className="py-4 px-4 border-b border-white/5">
                  <div className="font-display text-base text-white tracking-tight">
                    {home?.name} <span className="text-white/40 px-2">vs</span> {away?.name}
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.2em] text-white/50 mt-1">
                    {home?.abbr} / {away?.abbr}
                  </div>
                </td>
                <td className="py-4 px-4 border-b border-white/5 hidden md:table-cell">
                  <div className="flex items-center gap-2 text-white/85">
                    <MapPin className="h-3.5 w-3.5 text-pshl-electric" />
                    <span className="text-sm">{m.venue}</span>
                  </div>
                </td>
                <td className="py-4 px-4 border-b border-white/5 hidden sm:table-cell font-mono text-xs text-white/85">{m.time}</td>
                <td className="py-4 px-4 border-b border-white/5 text-right">
                  <span className="inline-block text-[10px] font-display uppercase tracking-[0.2em] px-2 py-1 bg-pshl-electric/15 text-pshl-electric border border-pshl-electric/30">
                    {m.status}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
